import { render, staticRenderFns } from "./Candidat.vue?vue&type=template&id=4888539e"
import script from "./Candidat.vue?vue&type=script&lang=js"
export * from "./Candidat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports